import { useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from 'react-i18next';
import { Button } from "../button/button";
import { EditOrganizationModal } from "../organization-management/edit-organization-modal/edit-organization-modal";
import { ViewOrganizationModal } from "../organization-management/view-organization-modal/view-organization-modal";
import { OrganizationListTable } from "./organization-list-table";

const COMPONENT_CLASS = "c-organization-list";

/**
 * Super admin Organizations list: every organization, with plan and status
 * columns and a read-only view modal per row.
 */
export const SuperAdminOrganizationList: React.FC = () => {
    const history = useHistory();
    const { t } = useTranslation();

    const [editOrgId, setEditOrgId] = useState<string>();
    const [openEdit, setOpenEdit] = useState(false);
    const [viewOrgId, setViewOrgId] = useState<string>();
    const [viewOpen, setViewOpen] = useState<boolean>(false);

    return (
        <div className={`${COMPONENT_CLASS}`}>
            <div className={`${COMPONENT_CLASS}__header`}>
                <div className={`${COMPONENT_CLASS}__actions`}>
                    <Button
                        type="default"
                        onClick={() => history.push("/organization/")}
                        buttonText={t('buttons.btn_addOrg')}
                    />
                </div>
                <h1>{t('organization.edit.fields.accountManagement')}</h1>
            </div>
            <OrganizationListTable
                algoliaFilters=""
                showPlanStatus={true}
                onRowClick={(h) => {
                    setViewOrgId(h.id);
                    setViewOpen(true);
                }}
                onEdit={(h) => {
                    setEditOrgId(h.id);
                    setOpenEdit(true);
                }}
            />
            <EditOrganizationModal
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                organizationId={editOrgId}
            />
            <ViewOrganizationModal
                open={viewOpen}
                onClose={() => setViewOpen(false)}
                organizationId={viewOrgId}
                onEdit={() => {
                    setViewOpen(false);
                    setEditOrgId(viewOrgId);
                    setOpenEdit(true);
                }}
            />
        </div>
    );
};

export default SuperAdminOrganizationList;
